import { callAPI } from "../config/api";

const PATH_API = process.env.REACT_APP_API;

export async function signIn(data: any) {
    const url = `${PATH_API}/authenticate`;
    return await callAPI({
        url,
        method: "POST",
        data,
    });
}

export async function signUp(data: any) {
    const url = `${PATH_API}/signup`;
    return await callAPI({
        url,
        method: "POST",
        data,
    });
}


export async function forgetPassword(data: any) {
    const url = `${PATH_API}/forget-password`;
    return await callAPI({
        url,
        method: "POST",
        data,
    });
}

export async function verifyOtp(data: any) {
    const url = `${PATH_API}/verify-otp`;
    return await callAPI({
        url,
        method: "POST",
        data,
    });
}

export async function resetPassword(data: any) {
    const url = `${PATH_API}/reset-password`;
    return await callAPI({
        url,
        method: "POST",
        data,
    });
}

export async function searchMitra(params: any) {
    const url = `${PATH_API}/search`;
    return await callAPI({
        url,
        method: "GET",
        params
    });
}